import application from "stimulus_application";
import ClientsWallController from "./clients_wall_controller";
import "./clients_wall.css";

application.register("clients-wall", ClientsWallController);
